export default __webpack_public_path__ + "static/media/MedicineIcon.4ce38f06.svg";